module.exports = __webpack_public_path__ + "media/fonts/calibri/Calibri-Italic-aff043d440c38fcd00de4aa8e4ab94cf.ttf";